import { useAppStore } from '../store/appStore';
import { BACKOFFICE_PILOT_MISSIONS_MODERATE } from '../consts/permissions';

export const useIsMissionModerator = () => {
  const { permissions } = useAppStore();

  if (!permissions) {
    return null;
  }

  return permissions?.systemLevel.includes(BACKOFFICE_PILOT_MISSIONS_MODERATE) ?? false;
};
